import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { fileUrl, ownerApi } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Spinner, EmptyState } from "@/components/common/States";
import { cn } from "@/lib/utils";

export default function OwnerCommunity() {
  const queryClient = useQueryClient();
  const [filter, setFilter] = useState("pending");
  const query = useQuery({ queryKey: ["ownerCommunity", filter], queryFn: () => ownerApi.getCommunityRequests(filter) });
  const invalidate = () => queryClient.invalidateQueries({ queryKey: ["ownerCommunity"] });

  const review = (id, action) => {
    const reason = action === "reject" ? window.prompt("Reason (optional)") ?? "" : "";
    ownerApi.reviewCommunityRequest(id, action, reason).then(() => { invalidate(); toast.success(action === "approve" ? "Approved" : "Rejected"); }).catch((e) => toast.error(e.message));
  };

  return (
    <div className="space-y-4">
      <div className="flex gap-2">
        {["pending", "approved", "rejected"].map((f) => (
          <button key={f} onClick={() => setFilter(f)} className={cn("rounded-full px-4 py-1.5 text-xs font-semibold capitalize", filter === f ? "bg-primary text-primary-foreground" : "bg-secondary text-muted-foreground")}>{f}</button>
        ))}
      </div>
      {query.isPending ? <Spinner /> : !query.data?.length ? <EmptyState title="No requests" /> : (
        <div className="grid gap-3 sm:grid-cols-2">
          {query.data.map((r) => (
            <div key={r.id} className="rounded-2xl border border-border bg-card p-4">
              <div className="flex items-center justify-between">
                <p className="font-medium">{r.customer_name || r.phone}</p>
                {r.ai_flag ? <span className="rounded-full bg-[hsl(var(--warning)/0.15)] px-2 py-0.5 text-xs text-[hsl(32_100%_40%)]">AI flag</span> : null}
              </div>
              <p className="text-xs text-muted-foreground">{r.category} · {fmtDateTime(r.created_at)}</p>
              {r.ai_note ? <p className="mt-1 text-xs text-muted-foreground">AI: {r.ai_note}</p> : null}
              {r.proof_path ? <img src={fileUrl(r.proof_path)} alt="proof" className="mt-2 h-32 w-full rounded-lg border border-border object-cover" /> : null}
              {filter === "pending" ? (
                <div className="mt-3 flex gap-2">
                  <button onClick={() => review(r.id, "approve")} className="flex-1 rounded-full bg-primary py-1.5 text-xs font-semibold text-primary-foreground">Approve</button>
                  <button onClick={() => review(r.id, "reject")} className="flex-1 rounded-full border border-destructive py-1.5 text-xs font-semibold text-destructive">Reject</button>
                </div>
              ) : <p className="mt-2 text-xs font-semibold capitalize text-muted-foreground">{r.status}{r.reject_reason ? ` · ${r.reject_reason}` : ""}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
